// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2qNRE","footer":"Form_footer__1vgCe"};